import { EventType } from 'api/notifications/meta';
import { NotificationGroups } from './notification-group.types';

type NotificationByGroupsType = {
  [propname in NotificationGroups]: EventType[];
};

export const NotificationsByGroup: NotificationByGroupsType = {
  [NotificationGroups.Task]: [
    EventType.TaskCreated,
    EventType.TaskStatusChanged,
    EventType.TaskAssigneeChanged,
    EventType.TaskAttachmentChanged,
    EventType.TaskStartDateChanged,
    EventType.TaskDueDateChanged,
    EventType.TaskFieldChanged,
    EventType.TaskRequestApproval,
  ],
  [NotificationGroups.Message]: [
    EventType.MessageCreatedInTask,
    EventType.MessageCreatedInProjectConversation,
    EventType.MessageCreatedInDocumentSpaceTab,
    EventType.MessageCreatedInDocumentStatusUpdate,
  ],
  [NotificationGroups.Project]: [
    EventType.ProjectMemberAdded,
    EventType.ProjectMemberRemoved,
    EventType.ProjectCsatAdded,
    EventType.ProjectStartDateOrDueDateChanged,
    EventType.ProjectStatusUpdatePublished,
    EventType.ProjectAnyFieldChanged,
    EventType.ProjectArchived,
    EventType.ProjectDeleted,
    EventType.ProjectFieldUpdated,
    EventType.ResourceRequestStatusChanged,
    EventType.ResourceRequestApproved,
    EventType.ResourceRequestSetAssignee,
    EventType.ResourceRequestAssigneeChanged,
    EventType.ResourceRequestAssigneeUpdated,
  ],
  [NotificationGroups.Phase]: [
    EventType.ProjectPhaseAdded,
    EventType.ProjectPhaseDueDateChanged,
    EventType.ProjectPhaseStartDateChanged,
    EventType.ProjectPhaseStatusChanged,
  ],
  [NotificationGroups.Forms]: [EventType.TaskFormResponseChanged],
  [NotificationGroups.Space]: [
    EventType.DocumentCreated,
    EventType.ProjectSpaceCreated,
    EventType.ProjectDocumentAdded,
    EventType.ProjectDocumentApprovalRequests,
    EventType.ProjectDocumentComments,
  ],
  [NotificationGroups.Remainders]: [
    EventType.StartDateReminders,
    EventType.DueDateReminders,
    EventType.DigestTaskStartDateReminder,
    EventType.DigestTaskDueDateReminder,
  ],
  [NotificationGroups.TasksDigest]: [
    EventType.DigestWeekly,
    EventType.DigestTask,
    EventType.DigestTaskWeekly,
  ],
  [NotificationGroups.Approvals]: [EventType.AllApprovalEvents],
  [NotificationGroups.ResourceRequest]: [
    EventType.ResourceRequestStatusChanged,
    EventType.ResourceRequestApproved,
    EventType.ResourceRequestSetAssignee,
    EventType.ResourceRequestAssigneeChanged,
    EventType.ResourceRequestAssigneeUpdated,
  ],
};
